export const MAX_NUMBER_OF_CHARACTERS = 10000;
